"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraError = exports.StyledOr = exports.StyledInvalid = exports.StyledImageSrc = exports.StyledLabel = exports.StyledVideo = void 0;
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledVideo = styled_components_1.default.video `
  display: inline-block;
  border-radius: 12px;
  height: 200px;
  width: 100%;
  max-width: 350px;
  margin: auto;
  box-sizing: border-box;
`;
exports.StyledLabel = styled_components_1.default.label `
  background-color: ${bitcoincom_pkg_theme_1.colors.solid.primaryBlue};
  color: ${bitcoincom_pkg_theme_1.colors.solid.white};
  width: 100%;
  border-radius: 12px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 14px;
  input[type="file"] {
    display: none;
  }
`;
exports.StyledImageSrc = styled_components_1.default.div `
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  text-align: center;
  margin-top: 16px;
`;
exports.StyledInvalid = styled_components_1.default.div `
  color: ${bitcoincom_pkg_theme_1.colors.solid.primaryRed};
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  width: 100%;
  margin-top: 16px;
`;
exports.StyledOr = styled_components_1.default.div `
  text-align: center;
  color: #3e4555;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.09px;
  width: 100%;
  margin: 14px auto 16px;
`;
exports.CameraError = styled_components_1.default.div `
  width: 350px;
  height: 200px;
  background-color: black;
  border-radius: 12px;
  font-weight: 600;
  color: white;
  font-size: 14px;
  line-height: 16.71px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  svg {
    color: #f19e0f !important;
  }
`;
//# sourceMappingURL=styled.js.map